import React, { useMemo, useState } from 'react';
import { Popover, IconButton, Input, InputLabel, InputAdornment, FormControl } from '@material-ui/core';
import moment from 'moment';
import { CalendarToday } from '@material-ui/icons';
import { DatePickerModal } from '../DatePickerModal';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

interface IProps {
  label: string;
  value: Date | null;
  minDate?: Date | undefined;
  modalTitle: string;
  handleChange: (event: Date | null) => void;
}

export const DatePickerInput = ({ label, handleChange, value, modalTitle, minDate }: IProps) => {
  const [open, setOpen] = useState(false);
  const [inputText, setInputText] = useState('');

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [placement, setPlacement] = useState<string>();

  const handleClick = (event: React.MouseEvent) => {
    const newPlacement = 'bottom';
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const handleDtCalendar = (date: MaterialUiPickersDate | null) => {
    handleChange(date);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;

    if (target) {
      const value = target.value;
      setInputText(value);
    }
  };

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const target = event.target;
    const value = target.value;
    const date = moment(value, 'DD/MM/YYYY');
    if (date.isValid()) {
      handleChange(date.toDate());
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const inputValue = useMemo(() => {
    if (!inputText && value) return moment.utc(value).format('DD/MM/YYYY');
    return inputText;
  }, [value, inputText]);

  return (
    <>
      <FormControl style={{ width: '100%' }}>
        <InputLabel htmlFor="standard-adornment-password">{label}</InputLabel>
        <Input
          type="text"
          onChange={handleInputChange}
          onBlur={handleOnBlur}
          value={inputValue}
          endAdornment={
            <InputAdornment position="end">
              <IconButton color="primary" aria-label="Escolha data" onClick={handleClick}>
                <CalendarToday />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <Popover
        id="datepickerModalCalendar"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        onClose={handleClose}
      >
        <DatePickerModal
          handleCalendarChange={handleDtCalendar}
          handleClose={handleClose}
          modalTitle={modalTitle}
          value={value}
          minDate={minDate}
        />
      </Popover>
    </>
  );
};
